module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "gwi-myPayDetail"
    }
  }, [_c('scroll', {
    staticClass: "scroll-height",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('section', {
    staticClass: "thick"
  }, [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("医院")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.hospitalName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("姓名")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.param.queryParam.holderName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("卡号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.param.queryParam.cardNo) + "\n        ")])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("时间")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatpayDate")(_vm.param.queryParam.orderTime)))])])]), _vm._v(" "), _vm._l((_vm.payDetailList), function(item, index) {
    return _c('div', {
      key: index,
      attrs: {
        "id": 'myPayDetail-payDetail-' + index
      }
    }, [_c('section', {
      staticClass: "thick mythick"
    }, [_c('div', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.showDetail(item)
        }
      }
    }, [_c('span', {
      staticClass: "f-strong"
    }, [_vm._v(_vm._s(item.recipeName))]), _vm._v(" "), _c('div', {
      staticClass: "mytitle"
    }, [_c('span', {
      staticClass: "f-strongest"
    }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.param.queryParam.fee)))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.showDetailInfo),
        expression: "!item.showDetailInfo"
      }],
      staticClass: "arr-gray-down"
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showDetailInfo),
        expression: "item.showDetailInfo"
      }],
      staticClass: "arr-gray-up"
    })])]), _vm._v(" "), (item.items.length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showDetailInfo),
        expression: "item.showDetailInfo"
      }]
    }, _vm._l((item.items), function(subItem) {
      return _c('div', {
        key: subItem.item,
        staticClass: "report-detail"
      }, [_c('div', {
        staticClass: "field myfield"
      }, [_c('div', [_c('label', [_vm._v(_vm._s(subItem.itemName))])])]), _vm._v(" "), _c('div', {
        staticClass: "report-table-container"
      }, [_c('table', {
        staticClass: "report-table"
      }, [_c('tr', [_c('td', {
        staticClass: "f-minor"
      }, [_vm._v("单价")]), _vm._v(" "), _c('td', {
        staticClass: "f-minor"
      }, [_vm._v("数量")]), _vm._v(" "), _c('td', {
        staticClass: "f-minor"
      }, [_vm._v("总价")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatFee")(subItem.itemFee, false)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatItemQty")(subItem.itemQty)))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("formatFee")((subItem.itemFee * subItem.itemQty))) + "\n                  ")])])])])])
    }), 0) : _vm._e()])])
  })], 2), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "goPay"
  }, [_c('span', [_vm._v("总金额")]), _vm._v(" "), _c('span', {
    staticClass: "f-strongest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.param.queryParam.fee)))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7592ef0c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/hospitalCostList/HospitalCostListDetail.vue
// module id = 856
// module chunks = 0